import LoginScreen from "@/screens/LoginScreen";

export default LoginScreen;
